import { createFileRoute, Navigate } from '@tanstack/react-router'
import { reportDetailSearchSchema } from '@/schemas'
import { ReportDetails } from '@/pages'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

export const Route = createFileRoute('/_layout/reporting/$reportId/')({
    component: () => <RouteComponent />,
    validateSearch: reportDetailSearchSchema,
})

export const RouteComponent: React.FC = () => {
    const { reportId } = Route.useParams()

    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>
            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <ReportDetails reportId={reportId} />
            </RoleRestrictedContent>
        </>
    )
}
